import React, {useContext} from 'react';
import {Card} from "../../../../../../components/card/card.jsx";
import SentryRow from "../../../../../../components/template/sentry-row.jsx";
import InputForm from "../../../../../../components/input/input-form.jsx";
import {IndividualContext} from "../../individual-context.jsx";
import useFetchData from "../../hooks/use-fetch-data.js";
import SelectComponent from "../../../../../../components/select/select-component.jsx";
import Button from "../../../../../../components/button/button.jsx"
import {FaExternalLinkAlt} from "react-icons/fa";
import InputTextarea from "../../../../../../components/input/input-textarea.jsx";

const OtherInformation = () => {
    const {individual, setIndividual, setChanges} = useContext(IndividualContext)
    const {situations, instructions} = useFetchData()

    const onChange = ({target: {id, value}}) => {
        setIndividual(prev => ({...prev, [id]: value}));
        handleChanges()
    }

    const onChangeCustom = (value, id) => {
        setIndividual(prev => ({...prev, [id]: value}))
        handleChanges()
    }

    const handleChanges = () => {
        setChanges(prev => (prev.includes("other-information") ? prev : [...prev, "other-information"]))
    }

    const openSocialNetwork = () => {
        let link = individual.socialNetwork
        if (link) {
            if (link.indexOf('http://') < 0 && link.indexOf('https://') < 0) {
                link = `https://${link}`;
            }

            window.open(link, '_blank');
        }
    }

    return (
        <Card>
            <Card.Body>
                <SentryRow>
                    <div className="col-span-12">
                        <InputForm
                            id="roleCrime"
                            value={individual.roleCrime}
                            label="Função no crime"
                            onChange={onChange}/>
                    </div>

                    <div className="col-span-6">
                        <SelectComponent
                            id={"situation"}
                            value={individual.situation}
                            options={situations}
                            label={"Situação"}
                            onChange={(value) => onChangeCustom(value?.value, "situation")}
                        />
                    </div>
                    <div className="col-span-6 flex gap-2">
                        <InputForm
                            classNameWrapper={"w-full"}
                            id="socialNetwork"
                            value={individual.socialNetwork}
                            label="Rede social"
                            onChange={onChange}/>
                        <Button onClick={openSocialNetwork}>
                            <FaExternalLinkAlt />
                        </Button>
                    </div>

                    <div className="col-span-6">
                        <SelectComponent
                            id={"educationDegree"}
                            value={individual.educationDegree}
                            options={instructions}
                            label={"Grau de instrução"}
                            onChange={(value) => onChangeCustom(value?.value, "educationDegree")}
                        />
                    </div>
                    <div className="col-span-6">
                        <InputForm
                            id="occupation"
                            value={individual.occupation}
                            label="Profissão"
                            onChange={onChange}/>
                    </div>

                    <div className="col-span-12">
                        <InputTextarea
                            id={"information"}
                            value={individual.information}
                            label="Informações do indivíduo"
                            textAreaClass={"h-[100px]"}
                            onChange={onChange}
                        />
                    </div>
                </SentryRow>
            </Card.Body>
        </Card>
    );
};

export default OtherInformation;
